import Vue from 'vue'
import Router from 'vue-router'
import Fill from '@/components/Fill'
import Edit from '@/components/Edit'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/fill/:inputText',
      name: 'Fill',
      component: Fill
    },
    {
    path:'/edit/:inputText?',
    name:'Edit',
    component: Edit,
  },
    { path: '/', redirect: { name: 'Edit' }}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js